import {Component} from '@angular/core';

/* Body only -- HelpDialogComponent supplies the dialog chrome and Okay button. */
@Component({
    selector: 'app-portfolio-help',
    templateUrl: './portfolio-help.component.html'
})
export class PortfolioHelpComponent {
}
